import { Box, Typography, Container } from '@mui/material';

function Hero() {
  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 8,
        textAlign: 'center'
      }}
    >
      <Container>
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to Bhaktivedanta Vedic Academy
        </Typography>
        <Typography variant="h5" component="h2">
          Explore the timeless wisdom of Vedic knowledge
        </Typography>
      </Container>
    </Box>
  );
}

export default Hero; 